import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "map-enlarge",
  "use": "map-enlarge-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"map-enlarge\">\r\n<path d=\"M2.33301 2.33331L9.33301 9.33331M2.33301 2.33331H9.33301M2.33301 2.33331V9.33331M25.6663 2.33331L18.6663 9.33331M25.6663 2.33331H18.6663M25.6663 2.33331V9.33331M25.6663 25.6666L18.6663 18.6666M25.6663 25.6666V18.6666M25.6663 25.6666H18.6663M2.33301 25.6666L9.33301 18.6666M2.33301 25.6666H9.33301M2.33301 25.6666V18.6666\" stroke=\"#3A3A3A\" stroke-width=\"3\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol